export default __webpack_public_path__ + "static/media/fishing-village.8da6cfa5.svg";